
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-black/30'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/be9e93ad-d23b-490f-9204-c4dc50969a8c.png" 
            alt="SYLPA S.R.L. Logo" 
            className="h-10 w-10 object-contain"
          />
          <span className={`text-lg font-medium transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
            SYLPA S.R.L.
          </span>
        </div>
        <div className="flex items-center gap-10">
          {['home', 'about', 'products', 'features', 'contact'].map((item) => (
            <button
              key={item}
              onClick={() => scrollToSection(item)}
              className={`text-sm font-light capitalize transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
